import { ErrorHandler, inject, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorReportingService } from './error-reporting.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private errorReportingService = inject(ErrorReportingService);


  handleError(error: unknown): void {
    const unwrappedError = (error as any)?.rejection ?? error;

    console.error(error);

    if (unwrappedError instanceof HttpErrorResponse) {
      return;
    }

    this.errorReportingService.reportError(unwrappedError);
  }
}
